<template>
  <div id="modalLogsTicket" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Logs do Ticket {{ ticketId }}</h5>
          <div>
            <button
              type="button"
              class="btn btn-primary"
              title="Sincronizar Logs"
              :disabled="isSyncingLogs"
              @click="syncTicketLog"
            >
              <span v-if="isSyncingLogs">
                <i class="ph ph-spinner spinner me-2" /> Sincronizando
              </span>
              <span v-else>Sincronizar Logs</span>
            </button>
            <button
              type="button"
              class="btn-close ms-3"
              data-bs-dismiss="modal"
              title="Fechar"
              @click="$emit('closeModal', true)"
            />
          </div>
        </div>
        <div v-if="logs.length > 0" class="table-responsive">
          <table class="table table-striped table-sm table-bordered fs-sm">
            <thead>
              <tr>
                <th class="col text-center">Data</th>
                <th class="col text-center">Tipo</th>
                <th class="col">Usuário</th>
                <th class="col-4">Descrição</th>
                <th class="col text-center">Tempo (minutos)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.id">
                <td class="text-center">
                  {{ convertTimestampToBrazilianDate(log.createTime) }}
                </td>
                <td class="text-center">
                  {{ log.appUserContactType }} / {{ log.type }}
                </td>
                <td>{{ log.contactName }}</td>
                <td>{{ log.body }}</td>
                <td class="text-center">
                  {{ convertSecondsToHours(log.timeTracked) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="modal-body text-center pb-0">
          Nenhum log encontrado
        </div>
        <div class="modal-footer border-top-0 pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', true)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'
import {
  convertTimestampToBrazilianDate,
  convertSecondsToHours,
} from '@/utils/date'

export default {
  name: 'LogsTicketModal',

  props: {
    ticketId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSyncingLogs: false,
      logs: [],
      convertTimestampToBrazilianDate,
      convertSecondsToHours,
    }
  },

  methods: {
    async getTicketLog() {
      try {
        this.logs = await this.$store.dispatch('getTicketLogs', this.ticketId)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', true)
      }
    },

    async syncTicketLog() {
      try {
        this.isSyncingLogs = true
        const response = await this.$store.dispatch(
          'syncTicketLogs',
          this.ticketId,
        )
        this.$root.$refs.notification.success(response.message)

        this.isSyncingLogs = false
        this.getTicketLog()
      } catch (error) {
        this.isSyncingLogs = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  async mounted() {
    await this.getTicketLog()
    showModal('modalLogsTicket')
  },
}
</script>
